import React from 'react';
import { Stack, Typography, useTheme } from '@mui/material';

import { Props } from './props';
const InfoCard: React.FC<Props> = (props) => {
  const { icon, title, titleProps, desc, header, ...restProps } = props;
  const theme = useTheme();
  return (
    <Stack
      {...restProps}
      sx={{
        background: theme.palette.customColors.cardBg,
        padding: '16px',
        borderRadius: '8px',
        ...restProps?.sx,
      }}
    >
      {icon && (
        <Stack sx={{ flexDirection: 'row', alignItems: 'center', gap: 1 }}>
          {icon}
          {header && (
            <Typography
              sx={{
                fontWeight: 600,
                color: 'primary',
                fontSize: 14,
              }}
              {...titleProps}
            >
              {header}
            </Typography>
          )}
        </Stack>
      )}
      <Typography
        sx={{
          fontWeight: 600,
          color: 'primary',
          fontSize: 14,
        }}
        {...titleProps}
      >
        {title}
      </Typography>
      {desc && desc}
    </Stack>
  );
};

export default InfoCard;
